import { Spacing } from '@persona-id/design-tokens';
import { FONT_SIZES } from 'shared/styles/variables';
import styled, { DefaultTheme } from 'styled-components';

import { InputSizes } from 'design-system/mixins/input';

function determineFormErrorSize(size: InputSizes, theme: DefaultTheme) {
  switch (size) {
    case 'md':
      return theme.text.paragraph.sm.fontSize;
    case 'sm':
      return theme.text.paragraph.xs.fontSize;
  }
}

const FormError = styled.div.attrs(() => ({ 'data-test': 'form-error' }))<{ size?: InputSizes }>`
  color: ${({ theme }) => theme.colorError};
  font-size: ${({ theme, size }) =>
    size != null ? determineFormErrorSize(size, theme) : FONT_SIZES.small};
  margin-top: ${Spacing[2]};
`;

export default FormError;
